module.exports = __webpack_public_path__ + "img/video_empty.edaa2d65.jpg";